@for (message of messages(); track message.text) {
	<div @expandCollapse class="{{ message.style }}">
		<div role="alert">
			@if (message.isLoginFailureMessage) {
				<p class="sr-only">We are unable to look up your claim with the information provided.</p>
			}
			<p [innerHTML]="message.text" class="ao-left-32"></p>
		</div>
	</div>
}
